import React, {useEffect, useState, useContext} from 'react';
import {Popover, Button, message} from 'antd';
import {AxiosRequestWithImba} from "../../helpers/AxiosRequest";
import {RoleContext} from "../../contexts/RoleContext";


const Complete = ({record, imba_id}) => {
    const [visible, setVisible] = useState(false);

    const success = (text) => {
        message.success(text);
    };

    const onDelete = (item) => {
        AxiosRequestWithImba('delete_note_list', {
            messageId: record.id,
            room_id: -1,
            admin: localStorage.getItem('comet-user-id')
        }, imba_id).then((data) => {
            if (!data.error)
            {
                success('Successfully deleted!')
                setVisible(false)
            }
        })
    }

    const handleVisibleChange = (visible) => {
        setVisible(visible)
    };

    const content = (
        <div>
            <Button className={'m-1'} onClick={() => onDelete(record)}>OK</Button>
        </div>
    );
    const {getRole} = useContext(RoleContext);
    const {setRole} = useContext(RoleContext);
    const role = getRole()

    if(role !='operator'){
    return (
        <Popover visible={visible} placement="topLeft" title={'Confirm delete'} content={content} trigger={'click'} onVisibleChange={handleVisibleChange}>
            <a className={'button'} style={{ margin: '0 8px' }} id={`ban-${record.id}`}>Complete</a>
        </Popover>
    );
    }
    else{
        return (
            <>
            </>
        );
    }
};


export default Complete;